<!--  -->
<template>
  <div>

    <el-form :model="uploadForm" ref="upload" :rules="rules" label-width="120px" label-position="right">
      <el-form-item prop="files" label="选择文件">
        <el-upload ref="upload"  name="file" :on-change="handleChange"  :file-list="fileList"  action=""  :http-request="httpRequest" :on-remove='removeList'>
          <el-input  readonly style="width:200px;">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </el-upload>
      </el-form-item>
      <el-form-item prop="docComments" label="文件描述">
        <el-input style="width:200px;"  placeholder="" type="textarea" maxlength="100" show-word-limit v-model="uploadForm.docComments"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary"  @click="uploading('ruleForm')">上传</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import ratingTask from "@/api/AAA/ratingTask.js";
import { fileService } from "@/api/common/file-utils"

export default {
  props:['url','headerData','tsReckindId'],
  data () {
    return {
      fileList:[],
       uploadForm: {
          files: [],
          docComments:"",
        },
        rules: {
          files: [
            { required: true, message: '请上传文件', trigger: 'blur' },
          ],
          docComments: [
            { required: true, message: '请输入文件描述', trigger: 'blur' },
          ],
        },
    };
  },

  components: {},

  computed: {},

  methods: {
    httpRequest(param){
      this.uploadForm.files.push(param.file)
    //   if(this.url!='/api/order/itemcodeSummaryHeader/uploadWeeklyProductionSchedule'){
    //     if(this.uploadForm.files.length>1){
    //       this.uploadForm.files.splice(0,1)
    //     }
    //   }
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
       if (fileList.length > 1) {
            // this.uploadForm.files = [fileList[fileList.length - 1]]  
            this.uploadForm.files.splice(0,1)
       }
    },
    uploading(){
      this.$refs['upload'].validate((valid) => {
        if (valid) {
            let formData = new FormData();
            this.uploadForm.files.forEach((v)=>{
              console.log("vvvvvvvvvvvvvv",v)
                formData.append('file',v,v.name)
            })
            fileService.fileUpload(formData).then((res) => {
                let attachment = {};
                attachment.documents = res.data;
                attachment.documents[0].docComments=this.uploadForm.docComments
                attachment.seq = '1';
                attachment.tsRecId =this.headerData.ttRmcProduceScoreId;
                attachment.tsReckindId = 'RMC_PRODUCE_SCORE';
                fileService.saveFile(attachment).then((saveRes) => {
                    if(saveRes.code==200){
                        this.$message.success('保存成功')
                        this.$emit('close')
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            }).catch((error) => {
            //文件上传失败
              this.$message.error('文件上传失败')
            });
        }
      })
    },
    removeList(file, fileList){
      this.uploadForm.files=fileList
      if(fileList.length==0){
        this.uploadForm.files=[]
      }
    },
    close(){
      this.$emit('close')
    }
  }
}

</script>
<style  scoped>
</style>
